import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { EMPTY, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-device-new-peripheral-creation-card',
  templateUrl: './device-new-peripheral-creation-card.component.html',
  styleUrls: ['./device-new-peripheral-creation-card.component.scss']
})
export class DeviceNewPeripheralCreationCardComponent implements OnInit, OnDestroy {

  @Input() peripheralTypes;
  @Input() peripheralConnectionTypes;
  deviceInternalId;
  productIdPlaceholder: string;
  ipPlaceholder: string;
  btNamePlaceholder: string;
  macPlaceholder: string;
  passwordPlaceholder: string;
  showButton: boolean;
  savePeripheralSubscription: Subscription;
  actionList = [{ id: 'PUSH', value: 'PUSH' }, { id: 'RETURN', value: 'RETURN' }, { id: 'NEXTLOCATION', value: 'NEXTLOCATION' },  { id: 'RESET', value: 'RESET' }];
  basicDataForm = new FormGroup({
    active: new FormControl(true),
    peripheralName: new FormControl(null, Validators.required),
    peripheralType: new FormControl(null, Validators.required),
    peripheralConnectionType: new FormControl(null, Validators.required),
    connectionPort: new FormControl(null),
    vendorId: new FormControl(null),
    productId: new FormControl(null),
    ip: new FormControl(null),
    btName: new FormControl(null),
    mac: new FormControl(null),
    password: new FormControl(null),
    baud: new FormControl(null)
  });

  constructor(private devicesDevicesService: DevicesDevicesService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService) {
    this.ipPlaceholder = 'devices-page.ip address';
    this.btNamePlaceholder = 'devices-page.bluetooth name';
    this.macPlaceholder = 'devices-page.mac address';
    this.passwordPlaceholder = 'password';
    this.showButton = true;
    this.deviceInternalId = this.activatedRoute.snapshot.params['deviceid'];
  }

  ngOnInit() {
  }

  public addNewPeripheral() {
    this.savePeripheralSubscription = this.devicesDevicesService.savePeripheral(this.basicDataForm.get('active').value, null, this.deviceInternalId, this.basicDataForm.get('peripheralName').value, this.basicDataForm.get('peripheralType').value, this.basicDataForm.get('peripheralConnectionType').value, this.basicDataForm.get('connectionPort').value, this.basicDataForm.get('vendorId').value, this.basicDataForm.get('productId').value, this.basicDataForm.get('baud').value, this.basicDataForm.get('btName').value, this.basicDataForm.get('mac').value, this.basicDataForm.get('password').value, this.basicDataForm.get('ip').value).pipe(
      tap(o => this.snackbarService.open('devices-page.snackbar messages.added device peripheral', 'success')),
      tap(o => this.router.navigate(['../../'], { relativeTo: this.activatedRoute })),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.savePeripheralSubscription) { this.savePeripheralSubscription.unsubscribe(); }
  }
}
